<template>
  <div class="no-match-found">
    <div class="no-contest-thumbnail">
      <img :src="`${CFG_WIDGET_URL_BASE}/static-assets/images/cssimages/no-contest-cham.png`" alt />
    </div>
    <div class="no-contest-text" v-if="toShow === 'no_matches'">
      <p class="text">{{ translations.no_matches_text_1 }}</p>
      <p class="text">{{ translations.no_matches_text_2 }}</p>
    </div>
    <div class="no-contest-text" v-if="toShow === 'no_series'">
      <p class="text">{{ translations.no_series_text_1 }}</p>
      <p class="text">{{ translations.no_series_text_2 }}</p>
    </div>
    <div class="no-contest-text" v-if="toShow === 'no_feed'">
      <p class="text">{{ translations.no_feed_text_1 }}</p>
      <p class="text">{{ translations.no_feed_text_2 }}</p>
    </div>
    <div class="no-contest-text" v-if="toShow === 'no_lineup'">
      <p class="text">{{ translations.no_lineup_text_1 }}</p>
      <p class="text">{{ translations.no_lineup_text_2 }}</p>
    </div>
    <div class="no-contest-text" v-if="toShow === 'no_match_tips_list'">
      <p class="text">{{ translations.no_match_tips_list_text_1 }}</p>
      <p class="text">{{ translations.no_match_tips_list_text_2 }}</p>
    </div>
    <div class="no-contest-text" v-if="toShow === 'custom_message'">
      <p class="text">{{ plainMsg }}</p>
    </div>
  </div>
</template>
<script>

import { CFG_WIDGET_URL_BASE } from "../../assets/js/config";
export default {
  props: ["translations", "toShow", "plainMsg"],
  data() {
    return {
      CFG_WIDGET_URL_BASE
    }
  }
};
</script>
